export default __webpack_public_path__ + "static/media/cement.c0d1c9a1.jpg";